(function () {
  'use strict';

  var DESKTOP = 1008;

  function getElements() {
    var product = document.querySelector('.Product--redesign');
    if (!product) return null;
    return {
      product: product,
      gallery: product.querySelector('.Product__GalleryScroller'),
      infoWrapper: product.querySelector('.Product__InfoWrapper')
    };
  }

  function isDrawerOpen() {
    return !!document.querySelector('.Drawer[aria-hidden="false"]');
  }

  function onWheel(e) {
    if (window.innerWidth < DESKTOP) return;
    if (document.documentElement.classList.contains('zoom-active')) return;

    var target = e.target;
    if (!target || !target.closest) return;

    if (isDrawerOpen()) {
      if (
        target.closest('.Product__InfoWrapper') ||
        target.closest('.Product__GalleryScroller')
      ) {
        e.preventDefault();
      }
      return;
    }

    var onGallery = !!target.closest('.Product__GalleryScroller');
    var onInfo = !!target.closest('.Product__InfoWrapper');
    var onProduct = onGallery || onInfo;

    var els = getElements();
    if (!els) return;

    var gallery = els.gallery;
    var infoWrapper = els.infoWrapper;
    var deltaY = e.deltaY;
    if (!deltaY) return;

    var pageScrollTop = window.scrollY || document.documentElement.scrollTop;

    // Gallery + Info hover: gallery → style with → page
    if (onProduct) {
      // Scrolling up: page must reach top first
      if (deltaY < 0 && pageScrollTop > 1) {
        e.preventDefault();
        window.scrollBy(0, deltaY);
        return;
      }

      var galleryMax = gallery ? gallery.scrollHeight - gallery.clientHeight : 0;
      var galleryTop = gallery ? gallery.scrollTop : 0;
      var galleryAtBottom = !gallery || galleryMax <= 1 || galleryTop >= galleryMax - 1;
      var galleryAtTop = !gallery || galleryTop <= 0;

      var infoMax = infoWrapper ? infoWrapper.scrollHeight - infoWrapper.clientHeight : 0;
      var infoTop = infoWrapper ? infoWrapper.scrollTop : 0;
      var infoAtBottom = !infoWrapper || infoMax <= 1 || infoTop >= infoMax - 1;
      var infoAtTop = !infoWrapper || infoTop <= 0;

      if (deltaY > 0) {
        // 1. Scroll gallery
        if (gallery && !galleryAtBottom) {
          e.preventDefault();
          gallery.scrollTop = Math.min(galleryMax, galleryTop + deltaY);
          return;
        }
        // 2. Scroll info wrapper (style with)
        if (infoWrapper && !infoAtBottom) {
          e.preventDefault();
          infoWrapper.scrollTop = Math.min(infoMax, infoTop + deltaY);
          return;
        }
        // 3. Let page scroll normally
        return;
      }

      if (deltaY < 0) {
        // Reverse: info wrapper first, then gallery
        if (infoWrapper && !infoAtTop) {
          e.preventDefault();
          infoWrapper.scrollTop = Math.max(0, infoTop + deltaY);
          return;
        }
        if (gallery && !galleryAtTop) {
          e.preventDefault();
          gallery.scrollTop = Math.max(0, galleryTop + deltaY);
          return;
        }
      }

      return;
    }

    // Sides / exit route: style with → page (skip gallery)
    if (infoWrapper) {
      // Scrolling up: page must reach top first
      if (deltaY < 0 && pageScrollTop > 1) {
        e.preventDefault();
        window.scrollBy(0, deltaY);
        return;
      }

      var infoMax = infoWrapper.scrollHeight - infoWrapper.clientHeight;
      var infoTop = infoWrapper.scrollTop;
      var infoAtBottom = infoMax <= 1 || infoTop >= infoMax - 1;
      var infoAtTop = infoTop <= 0;

      if ((deltaY > 0 && !infoAtBottom) || (deltaY < 0 && !infoAtTop)) {
        e.preventDefault();
        infoWrapper.scrollTop = Math.max(0, Math.min(infoMax, infoTop + deltaY));
        return;
      }
      // Info at boundary — let page scroll normally
    }
  }

  function init() {
    document.addEventListener('wheel', onWheel, { passive: false, capture: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
